module.exports = __webpack_public_path__ + "img/juheyun.df8cc6ec.png";